<template>
  <div>
    <div class="main-event-bn">
      <!-- <div class="bn-reward-value">
        {{ extractedNumber }}<span class="percent-unit">%</span>
      </div> -->
      <div class="main-title ff_Mincho">
        お客様限定オファー
      </div>
      <div class="subtitle-secondary-1">
        初回入金ボーナス100%
      </div>
      <div class="subtitle-secondary-2">
        +
      </div>
      <div class="subtitle-secondary-3">
        フリースピン20円Ｘ<span class="frequency">{{ extractedNumber }}</span>回
      </div>
      <img :src="require(`@/assets/theme_gold/images/main_bg.jpg`)" alt="Katsuwin Logo">
    </div>
    <section class="depiction">
      <!-- <p class="margin-tb">
        こんにちは。
      </p> -->
      <p class="margin-tb">
        お客様限定の特別なオファーをご用意いたしました。期間内にご入金いただくと、<br>【初回入金ボーナス100%+フリースピン20円 <b class="font-weight-800">X</b> <span class="frequency">{{ extractedNumber }}</span>回】を獲得可能です。
      </p>

      <p class="margin-b">
        勝winでキャッシュプレイゲームの素晴らしさと興奮をぜひご体験ください。この絶好の機会をお見逃しなく、お客様のご参加をお待ちしております。
      </p>

      <!-- <p class="margin-b">
        幸運をお祈りしております！
      </p> -->
    </section>
  </div>
</template>

<script>
import { login } from '@/api/user'
import { login as localLogin } from '@/utils/user'
import { showNotice } from '@/utils/tool'

export default {

  data() {
    return {
      extractedNumber: 12
    }
  },
  created() {
    const currentUrl = window.location.href
    const urlSegments = currentUrl.split('/')
    const numberFromUrl = parseInt(urlSegments[urlSegments.length - 2], 10)
    if (!isNaN(numberFromUrl)) {
      this.extractedNumber = numberFromUrl
    }
  },
  methods: {
    switchLoginType(loginType) {
      this.loginType = loginType
      this.postForm = {}
      this.$validator.errors.items = []
    },
    formatPhoneNumber(input) {
      if (this.loginType !== 'username') {
        const str = '' + input
        return '+81 ' + str.slice(0, 2) + '-' + str.slice(2, 6) + '-' + str.slice(6)
      }
    },
    toggleFlagShow() {
      this.isFlagShow = !this.isFlagShow
    },
    deactivatePopup() {
      this.$store.commit('SET_LOGIN_OPEN', false)
    },
    navigateToRegister() {
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_REGISTER_CHOOSE_OPEN', true)
    },
    navigateToForget() {
      this.$store.commit('SET_LOGIN_OPEN', false)
      this.$store.commit('SET_FORGET_OPEN', true)
    },
    clickLogin() {
      if (this.loginType === 'phone' && this.postForm.username !== null && this.postForm.username !== this.previousUsername) {
        this.postForm.username = this.formatPhoneNumber(this.postForm.username)
        this.previousUsername = this.postForm.username
      }
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          login(this.postForm).then(response => {
            let redirect = 'event'
            if (this.$store.getters.inviteCode !== null) {
              redirect = 'user'
            }
            const tokenData = response.data.data.token
            const expiredTime = new Date().getTime() + (tokenData.expired_interval * 1000)
            localStorage.setItem('expired_time', expiredTime)
            localStorage.setItem('token', tokenData.token)
            this.$store.commit('SET_LOGIN_TO_EVENT', true)
            this.$store.commit('SET_LOGIN_OPEN', false)
            this.$store.commit('SET_READ_TERMS', false)
            localLogin(response.data.data, redirect)
          }).catch((error) => {
            showNotice(error.response.data.msg)
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
